import { render, staticRenderFns } from "./declarant.vue?vue&type=template&id=67c4e86a"
import script from "./declarant.vue?vue&type=script&lang=js"
export * from "./declarant.vue?vue&type=script&lang=js"
import style0 from "./declarant.vue?vue&type=style&index=0&id=67c4e86a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports